<template>
  <div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		<div class="content">
		      <div class="content-main" v-if="info.no">
			        <div class="box-text" v-html="info.startContent">
			         	 
					 </div>
					 <div class="box-big-card">
			         	  <h3 class="name">추천 영상</h3>
						  <div class="box-card-top">
			         	         <div class="box-card" v-for="data in dataList" @click="goView(data.no)">
			         	                <div style='height:160px;overflow:hidden;width:100%'><img :src="'http://img.youtube.com/vi/'+data.vid+'/1.jpg'" style="width:100%;min-height:160px"></div>
			         	         		<p class="text-headr">
											{{data.subject}}
										</p>
			         	         		<p class="text-card">{{data.rdate}}</p> 
			         	         </div>
					 	  </div>
			        </div>
					<div class="box-text"  v-html="info.endContent">
			        </div>
			  </div>
			  <div class="content-main" v-else style="height:500px;line-height:500px;text-align:center;padding:0;">
				<h3>추천 영상이 존재하지 않습니다</h3>
			  </div>
	    </div>
		<FooterLayout></FooterLayout>
	</div>
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
	name: 'AdvisorList',
	components: {
		HeaderLayout,
		FooterLayout
	},
	data() {
		return {
			pagecode:'advisor',
			cmd:'list',
			dataList:[],
			info:{},

		}
	},
	created() {
		this.getData();
	},
    methods: {
	   getData() {
		  	var obj = this;
			this.$form.sendPost({cmd:'video'},'advisor/getDataList',function(resp) {
				if(resp.result=='succ') {
					obj.dataList = resp.dataList;
					obj.info = resp.info;

				} else {

				}
			},'multi');
	  
		},
		goView(no) {
			this.$router.push({path:'/advisor/view/'+no});
		},
		changePage(code) {
			switch(code) {
				case 'list':
					this.$router.push({path:'/advisor/list'});
				break;
				case 'sentence':
					this.$router.push({path:'/advisor/sentence'});
				break;
				case 'word':
					this.$router.push({path:'/advisor/word'});
				break;
				case 'problem':
					this.$router.push({path:'/advisor/gtest'});
				break;

			}
		}
	}
}
</script>

<style lang="scss" scoped>
*    {
     margin:0;
	 padding:0;
}
a    {
     text-decoration:none;
}
li    {
      list-style:none;
}
.page-container {
	width:100%;
	min-height:calc(100vh);
	background:#E6E8F4;
	.content   {
		width:100%;
		padding:180px 0 55px 0; 
		font-family: 'Nanum Gothic', sans-serif;
		.content-main	{
		                  width:830px;
						  margin:0 auto;
						  height:auto;
						  min-height:540px;
						  background:#fff;
						  padding:10px;
						  .box-text        {
						  		font-size:13px;
		                         color:#000;
								line-height:110%;
								height:auto;
								padding:20px;
								&:last-child        {
									padding-top:30px;
								}
						  }
						  .box-big-card     {
						  				   padding:10px 20px;
										   .name        {
										   		   font-size:14px;
		                         		           color:#3D79FE;
												   padding-bottom:10px;
										   }
										   .box-card-top      {
										   				display:flex;
														flex-wrap:wrap;
										   				.box-card       {
																   cursor:pointer;
																   width:243px;
																   height:200px;
																   margin:10px 20px 15px 0;
																   .text-headr        {
																				font-size:13px;
		                         		                                        color:#000;
																				line-height:15px;
																				padding-top:10px;
																				font-weight:bold;
																   }
																   .text-card          {
																   				font-size:10px;
		                         		                                        color:#B6B6B6;
																				padding-top:5px;
																  }
																  &:nth-child(3n+3) {
																	margin-right:0;		
																  }

																  
														}
														
														
										   }
						  }
		}
	}
}			

</style>